// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2irxb","title":"Info_title__1k86m","links":"Info_links__1o8yb","link":"Info_link__2Jfv6","logo":"Info_logo__2lZKU"};